/*
 *
 * Test constants
 *
 */

export const SAMPLE_ACTION = 'app/sample/SAMPLE_ACTION';
export const SAMPLE_ACTION_UPDATE = 'app/sample/SAMPLE_ACTION_UPDATE';
